interface Palette { primary: string; primaryHover: string; primaryLight: string; secondary: string; secondaryHover: string; accent: string; success: string; warning: string; }
const channels = (hsl: string) => hsl.split(/\s+/).map(v=>Number(v.replace('%','')));
function foreground(hsl: string) {
  const [h,s,l]=channels(hsl), saturation=s/100, light=l/100;
  const a=saturation*Math.min(light,1-light);
  const rgb=[0,8,4].map(n=>{const k=(n+h/30)%12;return light-a*Math.max(-1,Math.min(k-3,9-k,1));});
  const linear=rgb.map(v=>v<=.04045?v/12.92:((v+.055)/1.055)**2.4);
  const luminance=linear[0]*.2126+linear[1]*.7152+linear[2]*.0722;
  return luminance>.22 ? '225 40% 12%' : '0 0% 100%';
}
export function themeTokens(theme: Palette, dark: boolean): Record<string,string> {
  const [h,s,l]=channels(theme.primary);
  const primary=dark ? `${h} ${Math.min(s,85)}% ${Math.max(64,Math.min(l,78))}%` : theme.primary;
  const soft=`${h} ${dark?30:Math.min(s,75)}% ${dark?21:96}%`;
  return {
    '--dojo-primary':theme.primary,'--dojo-primary-hover':theme.primaryHover,'--dojo-primary-light':theme.primaryLight,
    '--dojo-primary-foreground':foreground(theme.primary),'--dojo-secondary':theme.secondary,'--dojo-secondary-hover':theme.secondaryHover,
    '--dojo-secondary-foreground':foreground(theme.secondary),'--dojo-accent-foreground':foreground(theme.accent),
    '--dojo-success-foreground':foreground(theme.success),'--dojo-warning-foreground':foreground(theme.warning),
    '--dojo-accent':theme.accent,'--dojo-success':theme.success,'--dojo-warning':theme.warning,
    '--primary':primary,'--primary-foreground':foreground(primary),'--ring':primary,'--input-focus':primary,
    '--accent':soft,'--accent-foreground':dark?primary:theme.primary,'--sidebar-primary':primary,
    '--sidebar-accent':soft,'--sidebar-accent-foreground':primary,'--sidebar-ring':primary,
    '--chart-1':primary,'--chart-2':theme.success,'--chart-3':theme.accent,
    '--wh-sidebar':`${h} ${Math.min(s,50)}% ${dark?8:14}%`,
    '--wh-sidebar-text':`${h} 35% 94%`,'--wh-sidebar-muted':`${h} 23% 73%`,
    '--wh-hero-soft':`${h} ${dark?32:70}% ${dark?18:95}%`,
    '--dojo-gradient-primary':`linear-gradient(125deg,hsl(${theme.primaryHover}),hsl(${theme.primary}))`,
    '--dojo-gradient-secondary':`linear-gradient(125deg,hsl(${theme.secondary}),hsl(${theme.secondaryHover}))`,
  };
}
